/*
 * Keeps the checkout shut until the shopper accepts the terms.
 *
 * Przelewy24 requires that acceptance inside the purchase path, and on Shopify
 * Basic the checkout itself cannot be extended — so the gate sits on the cart.
 * Both the drawer and the /cart page carry their own checkbox and their own
 * buttons, and either can start a checkout, so each is wired separately.
 *
 * Everything is bound through the document rather than to the elements
 * themselves: Dawn replaces the whole drawer markup on every cart change, which
 * would silently drop listeners attached to the old nodes. For the same reason
 * the state is re-applied whenever that markup is swapped — a fresh drawer
 * arrives with an unticked box and an enabled button, which is exactly the
 * combination we must not leave standing.
 */
(function () {
  if (window.__cartTermsReady) return;
  window.__cartTermsReady = true;

  function scopeOf(node) {
    // The drawer and the cart page are separate forms; never let one checkbox
    // unlock the other's button.
    return node.closest('cart-drawer, #main-cart-footer, .cart__footer, form[action*="/cart"]') || document;
  }

  function sync(box) {
    var scope = scopeOf(box);
    var allowed = box.checked;

    scope.querySelectorAll('button[name="checkout"]').forEach(function (button) {
      // An empty cart disables the button on its own; don't re-enable it here.
      if (button.hasAttribute('data-terms-empty')) return;
      if (allowed) {
        if (button.dataset.termsLocked === 'true') {
          button.removeAttribute('disabled');
          delete button.dataset.termsLocked;
        }
      } else if (!button.hasAttribute('disabled')) {
        button.setAttribute('disabled', 'disabled');
        button.dataset.termsLocked = 'true';
      }
    });

    scope.querySelectorAll('.cart__dynamic-checkout-buttons').forEach(function (block) {
      allowed ? block.removeAttribute('data-terms-blocked') : block.setAttribute('data-terms-blocked', '');
    });

    var hint = scope.querySelector('[data-cart-terms-hint]');
    if (hint && allowed) hint.hidden = true;
  }

  function syncAll() {
    document.querySelectorAll('[data-cart-terms]').forEach(sync);
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-cart-terms]')) sync(event.target);
  });

  // Pressing Enter in a quantity field submits the cart form, which would
  // otherwise reach the checkout without passing the button at all.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form.action || form.action.indexOf('/cart') === -1) return;
      var box = scopeOf(form).querySelector('[data-cart-terms]');
      if (!box || box.checked) return;
      event.preventDefault();
      var hint = scopeOf(form).querySelector('[data-cart-terms-hint]');
      if (hint) hint.hidden = false;
      box.focus();
    },
    true
  );

  var pending = null;
  new MutationObserver(function () {
    clearTimeout(pending);
    pending = setTimeout(syncAll, 50);
  }).observe(document.documentElement, { childList: true, subtree: true });

  syncAll();
  document.addEventListener('DOMContentLoaded', syncAll);
  document.addEventListener('shopify:section:load', syncAll);
})();
